<template>
  <div>
    <v-menu v-model:opened="addAssetsMenu">
      <template #activator="{ props }">
        <v-btn variant="outlined" block v-bind="props" @click="addAssetsMenu = !addAssetsMenu">
          {{ t('yard.buttons.addAssets') }}
          <v-icon>{{ addAssetsMenu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="isCreateAssetVisitDialogVisible = true">
          <v-list-item-title>
            <v-icon size="x-small" class="mr-2">mdi-truck-flatbed</v-icon>
            {{ t('yard.messages.createAssetVisit') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ t('yard.messages.simulateTheDriverCheckIn') }}
          </v-list-item-subtitle>
        </v-list-item>
        <v-spacer class="my-2" />
        <v-list-item @click="isCreateAssetContainerDialogVisible = true">
          <v-list-item-title>
            <v-icon size="x-small" class="mr-2">mdi-truck-trailer</v-icon>
            {{ t('yard.messages.createAsset') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ t('yard.messages.addOnlyAContainerTrailerToTheYard') }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-menu>
    <yard-view-asset-visit-create-dialog
      :warehouse-id="selectedWarehouse?.id"
      :is-visible="isCreateAssetVisitDialogVisible"
      @close="isCreateAssetVisitDialogVisible = false" />
    <yard-view-asset-container-create-dialog
      :warehouse-id="selectedWarehouse?.id"
      :is-visible="isCreateAssetContainerDialogVisible"
      @close="isCreateAssetContainerDialogVisible = false" />
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import YardViewAssetVisitCreateDialog from '@/modules/yard/components/AssetVisit/Dialogs/YardViewAssetVisitCreateDialog.vue';
import YardViewAssetContainerCreateDialog from '@/modules/yard/components/AssetContainer/YardViewAssetContainerCreateDialog.vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewCreateAssetsButton',
  components: {
    YardViewAssetVisitCreateDialog,
    YardViewAssetContainerCreateDialog
  },
  props: {
    selectedWarehouse: {
      type: Object,
      required: true
    }
  },
  setup() {
    const { t } = useI18n();
    const isCreateAssetVisitDialogVisible = ref(false);
    const isCreateAssetContainerDialogVisible = ref(false);
    const addAssetsMenu = ref(false);

    return {
      t,
      isCreateAssetVisitDialogVisible,
      isCreateAssetContainerDialogVisible,
      addAssetsMenu
    };
  }
});
</script>
